import { render } from "./IncomeReport.vue?vue&type=template&id=0691c63a"
import script from "./IncomeReport.vue?vue&type=script&lang=js"
export * from "./IncomeReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__